import { get, post, put } from '@/fn/ajax'

/**
 * @param  {any} query
 *  http://yapi.yanfaba.cn/project/74/interface/api/3475
 *  修改密码
 */
export async function setpassowrd(query: any) {
  const data = await post('/user/modify/password', query)
  return data
}

/**
 * @param  {any} query
 *  http://yapi.yanfaba.cn/project/74/interface/api/3800
 *  修改密码
 */
export async function getuser(query: any) {
  const data = await get('/user/mail/getuser', query, {
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    }
  })
  return data
}

/**
 * @param  {any} query
 *  http://yapi.yanfaba.cn/project/74/interface/api/3800
 *  修改密码
 */
export async function setnewpassword(query: any) {
  const data = await post('/user/mail/set/password', query)
  return data
}

